import * as React from "react";
import * as _ from 'lodash';
import moment from "moment";
import {useParams} from "react-router-dom";
import {Box, Grid, Typography, Stack, Chip, IconButton} from "@mui/material";
import {loadPatientById, patient, setPatient} from '../../store/reducers/patient';
import {useDispatch, useSelector} from "react-redux";
import makeStyles from "@mui/styles/makeStyles";
import {useTranslation} from "react-i18next";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

const useStyles = makeStyles((theme) => ({
    section: {
        marginBottom: "16px"
    },
    sectionHeader: {
        backgroundColor: theme.palette.background.paperDarker,
        height: "46px",
        paddingLeft: "20px",
        borderTopLeftRadius: "8px",
        marginBottom: "3px",
    },
    sectionHeaderExpand: {
        backgroundColor: theme.palette.background.paperDarker,
        height: "46px",
        paddingRight: "20px",
        borderTopRightRadius: "8px",
        color:"white",
    },
    sectionBody: {
        backgroundColor: theme.palette.background.paperDarker,
        borderBottomLeftRadius: "8px",
        borderBottomRightRadius: "8px",
        paddingLeft: "20px",
        paddingRight: "20px",
        paddingTop: "20px",
        paddingBottom: "20px",
    }

}));

export function AdmissionSection(props) {
    const dispatch = useDispatch();
    const classes = useStyles();
    const {t} = useTranslation();
    const [expand, setExpand] = React.useState(props.defaultExpand || false);

    return (
        <Grid container className={classes.section}>
            <Grid item xs={9} className={classes.sectionHeader}>
                <Typography sx={{lineHeight: "46px", fontWeight: "500", fontSize: "0.95rem"}}>{t(props.header)}</Typography>
            </Grid>
            <Grid item xs={3} container justifyContent="flex-end" className={classes.sectionHeaderExpand}>
                <Stack direction="row" alignItems="center" spacing={2}>
                    {props.requiredLeft != null && props.requiredLeft > 0 &&
                        <Chip sx={{height: "24px"}} label={t("{{requiredLeft}} unanswered", {requiredLeft: props.requiredLeft})}/>
                    }
                     <IconButton color="inherit" aria-label="expand" component="label" onClick={()=>setExpand(!expand)}>
                        {expand ?
                            <ExpandMoreIcon/>
                        :
                            <ExpandLessIcon/>
                        }
                    </IconButton>
                </Stack>
            </Grid>
            {expand &&
            <Grid item xs={12} className={classes.sectionBody}>
                { props.children }
            </Grid>
            }
        </Grid>
    )

}

export default AdmissionSection;